<template>
    <q-page>
        <div class="q-display-1">Zadania uzupełniające</div>

        <div class="tasks">
            <OptionalTaskComponent
                v-for="task in tasks"
                :key="task.optionalTaskId"
                :model="task"
                :editable="true"
                :inline="true"/>
        </div>

        <fixed-buttons>
            <q-btn
                flat
                style="font-size: 1.5rem" dense
                icon="add_circle"
                color="primary"
                @click="routeToNewTaskEditor">
                <q-tooltip anchor="top left">
                    Dodaj nowe zadanie
                </q-tooltip>
            </q-btn>
        </fixed-buttons>

    </q-page>
</template>
<script>
    import QIcon from 'quasar-framework/src/components/icon/QIcon'
    import PoleComponent from './pole/PoleComponent'
    import FixedButtons from './FixedButtons'
    import QTooltip from 'quasar-framework/src/components/tooltip/QTooltip'
    import OptionalTaskComponent from './OptionalTaskComponent'
    export default {
        name: 'Tasks',
        components: {OptionalTaskComponent, QTooltip, FixedButtons, PoleComponent, QIcon},
        mounted() {
            this.fetch()
        },
        methods: {
            fetch() {
                // this.$store.dispatch('fetchTask')
            },
            routeToNewTaskEditor () {
                this.$router.push({name: 'task-add'})
            }
        },
        data() {
            return {

            }
        },
        computed: {
            tasks () {
                return this.$store.getters.optionalTask
            }
        }
    }
</script>